import { useGoogleLogin, useGoogleOAuth } from '@react-oauth/google';
import { useEffect } from 'react';

import { analytics } from 'analytics';

import FullPageSpinner from '../components/FullPageSpinner';
import { useApiContext } from '../contexts/apiContext';
import { closePopupWindow } from '../utils/popup';

const SignInGoogleRedirectPage: React.FC = () => {
  const { api } = useApiContext();
  const { scriptLoadedSuccessfully } = useGoogleOAuth();
  const redirectSignIn = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
  });

  // Get the authorization code provided by Google redirect link from query params
  const code = new URLSearchParams(window.location.search).get('code');

  // Once the auth script is loaded, redirect to Google sign in page, which will
  // redirect back to this page with the authorization code. Then use that authorization
  // code to sign into our app and close this window on success.
  useEffect(() => {
    const handleGoogleAuth = async () => {
      if (!scriptLoadedSuccessfully) return;
      try {
        if (code) {
          const socialLoginRequest = { code };
          await api().currentUser.signInViaGoogle({ socialLoginRequest });
          closePopupWindow();
        } else {
          redirectSignIn();
        }
      } catch (error) {
        analytics.reportError('Error signing in with Google', { error });
      }
    };
    handleGoogleAuth();
  }, [scriptLoadedSuccessfully, code]);

  return <FullPageSpinner />;
};

export default SignInGoogleRedirectPage;
